import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import {
  Grid,
  Box,
  Card,
  Typography,
  CardContent,
  Divider,
  TextField,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import { useSearch } from "../../pages/App/Referral/Hooks/Usesearch";
import constant from "../../constants/constant";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useFormik } from "formik";
import * as Yup from "yup";
import classes from "./overviewCaseload/index.module.scss";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import { CurrentUserData, ReferralCaseLoad } from "./overviewCaseload/interface";
import { postcodeRegex } from "../../constants/defaultValues";
import { updateDetailsByCaseload } from "../../redux/action";
import { style } from "./overviewCaseload/style";
import atoms from "../atoms";
import SimilarSchoolModal from "./overviewCaseload/SimilarSchoolModal";
import ConfirmationModal from "../atoms/ConfirmationModal";

const { Button, Select, LightBox,} = atoms;

export default function AssignSechool({existingEmails,caseloadId,referralCaseload,refClosedStatus,rejectedStyles}:any) {
      const dispatch = useDispatch();
  const referralReducer = (state: any) => state?.referralReducer;
  const [homeSchoolConfirmation, setIsHomeSchoolConfirmation] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [isNewSchool, setIsNewSchool] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isButtonEnabled, setButtonEnabled] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [isHomeSchooling, setHomeSchooling] = useState();
  const [isNewSchoolDetail, setIsNewSchoolDetail] = useState<any>({});
  const [isSelectedSchoolDetail, setIsSelectedSchoolDetail] = useState<any>("");
  const [currentTab, setCurrentTab] = useState<string>("one");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [schoolExistsPayload, setSchoolExistsPayload] = useState<any>();
  const [isBackupSchoolDetail, setBackupSchoolDetail] = useState<any>({});
  const [isBackupNewSchool, setBackupNewSchool] = useState<any>(false);
  const { query, setQuery, setUserAccess } = useSearch();
  const placeholderObject = {
    label: "Please Search by name atleast 3 characters",
    code_number: "placeholder",
    isDisabled: true,
  };

   const getCustomDropdown = (response: any, name: string, last: string) => {
    let dropdown: any = [];
    response &&
      response?.forEach((value: any) => {
        if (isEditDetail) {
          dropdown.push({
            value: value.id,
            label: last ? value[name] + " " + value[last] : value[name],
            first_name: value[last],
            last_name: value[name],
            email: value.email,
            phone_no: value.phone_no,
            address: value.address,
            jobRole: value.jobRole,
            school_name: value.school_name,
          });
        } else {
          dropdown.push({
            value: value.id,
            label: last ? value[name] + " " + value[last] : value[name],
            email: value.email,
            jobRole: value.jobRole,
            phone_no: value.phone_no,
          });
        }
      });
    return dropdown;
  };


  const allschoolData = createSelector(referralReducer, (state) => ({
    schooList: getCustomDropdown(state?.allschoolData?.user, "school_name", ""),
  }));

  const { schooList } = useSelector(allschoolData);

  let schoolInitialValues = {
    first_name: "",
    last_name: "",
    email: "",
    postCode: "",
    phone_no: "",
    address: "",
    school_name: "",
    value: "",
    label: "",
    role: constant.ROLE.ALL_ACCESS,
    scope: constant.SCOPE.CLINICIAN,
  };

  const handleSelect = (e: any) => {
    setIsNewSchoolDetail(e);
    setIsSelectedSchoolDetail(e);
    setButtonEnabled(true);
  };

 
  const validation = useFormik<ReferralCaseLoad>({
    enableReinitialize: true,
    initialValues: schoolInitialValues,
    validationSchema: Yup.object({
      first_name: Yup.string().required("Please Enter First Name"),
      last_name: Yup.string().required("Please Enter Last Name"),
      address: Yup.string().required("Please Enter Address"),
      school_name: Yup.string()
        .required("Please Enter School Name"),
      email: Yup.string()
        .email("Invalid email")
        .test("unique-email", "Email already exists", function (value) {
          return !existingEmails?.includes(value?.toLowerCase());
        })
        .required("Email is required"),
      postCode: Yup.string()
        .matches(postcodeRegex, "Invalid postcode format")
        .required("Please Enter Postcode"),
      phone_no: Yup.number().required("Please Enter Mobile Number"),

      // modules: Yup.string().required("Please Select"),
    }),
    onSubmit: (values: ReferralCaseLoad) => {
      setIsNewSchoolDetail("");
      setBackupSchoolDetail(values);
      setBackupNewSchool(isNewSchool);

      let payload = {
        school_detail: values,
        isNewSchool: true,
      };
      const trimmedValue = values.school_name?.trim().toLowerCase();
      const exists = schooList.some((item: any) =>
        item.school_name.trim().toLowerCase().includes(trimmedValue)
      );

      if (!!trimmedValue && exists) {
        setOpenConfirm(true);
        setSchoolExistsPayload(payload);

      } else {
        setIsEditDetail(false);
        dispatch(updateDetailsByCaseload(caseloadId, payload));
      }
    },
  });

  useEffect(() => {
    if (!referralCaseload) return;
    const {
      school_detail,
      isNewSchool,
      isHomeSchooling,
    } = referralCaseload;
    const values = {
      first_name: school_detail?.first_name,
      last_name: school_detail?.last_name,
      email: school_detail?.contact_email || school_detail?.email,
      postCode: school_detail?.post_name,
      phone_no: school_detail?.contact_phone || school_detail?.phone_no,
      address: school_detail?.address,
      school_name: school_detail?.school_name,
      value: "",
      label: "",
      isNewSchool: isNewSchool,
    };

    setHomeSchooling(isHomeSchooling);
    setIsNewSchoolDetail(school_detail);
    setBackupSchoolDetail(school_detail);

    validation.setValues(values);
    setBackupNewSchool(isNewSchool);
    if (isNewSchool === true) {
      setCurrentTab("one");
    } else {
      setCurrentTab("two");
    }
    // eslint-disable-next-line
  }, [referralCaseload]);

  const handleSetSchool = () => {
    setCurrentTab("one");
    validation.resetForm();
    if (isBackupNewSchool) {
      validation.setValues(isBackupSchoolDetail);
    } else {
      setIsNewSchoolDetail(isBackupSchoolDetail);
    }
    setIsNewSchool(isBackupNewSchool);
    // dispatch(getUserList({ scope: constant.SCOPE.SCHOOL }));
    setIsEditDetail(true);
  };

  useLayoutEffect(() => {
    if (isNewSchool === false) {
      setIsSelectedSchoolDetail(isNewSchoolDetail);
    } else {
      setIsSelectedSchoolDetail(isBackupSchoolDetail);
    }
    // eslint-disable-next-line
  }, [isNewSchool]);

  const handleChange = (event: any) => {
    setCurrentTab(event.target.value);
    setIsNewSchool(event.target.value === "one");
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDataLoaded(true);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  const handleSearchGp = (value: string) => {
    setUserAccess("ques22");
    setQuery(value);
  };

  const getMemoOptionsBySchool = useMemo(() => {
    if (query?.length >= 3 && schooList?.length > 0) {
      return schooList.map((items: any) => {
        return {
          ...items,
          label: `${items?.school_name} (${items?.address}), ${items?.phone_no}`,
        };
      });
    }
    return [];
  }, [schooList, query]);

  const handleAssign = ({ isHomeSchool = false }) => {
    const payload = {
      school_detail: isHomeSchool ? {} : isNewSchoolDetail,
      isHomeSchooling: isHomeSchool,
      isNewSchool: isHomeSchool ? false : isNewSchool,
    };

    dispatch(updateDetailsByCaseload(caseloadId, payload));
    setBackupSchoolDetail(isNewSchoolDetail);
    setBackupNewSchool(isNewSchool);
    setIsEditDetail(false);
    setIsNewSchoolDetail({});
    setIsSelectedSchoolDetail({});
    setIsHomeSchoolConfirmation(false);
  };

    const userLoggedData: CurrentUserData | null = JSON.parse(
      localStorage.getItem("loginResponse") || "null"
    );

  const handleSchool = () => handleAssign({ isHomeSchool: false });
  const handleHomeSchool = () => setIsHomeSchoolConfirmation(true);

  const submitAddNewSchool = () => {
    dispatch(updateDetailsByCaseload(caseloadId, schoolExistsPayload));
    setOpenConfirm(false);
    setIsEditDetail(false);
  };

  const educationDetails = useMemo(() => {
    return (
      <Card variant="outlined" sx={style.card_custom}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            className={classes.clTitle}
            marginBottom={"1rem"}
          >
            <Grid sx={style.eduCard}>
              <Typography variant="h6" sx={{ mb: "0!important", mr: 2 }}>
                2. Education Setting Details
              </Typography>

              {isBackupSchoolDetail?.status ===
                constant.STATUS.NOT_REGISTERED && (
                <Typography variant="caption" sx={style.notRegister}>
                  Not Registered
                </Typography>
              )}
              {dataLoaded &&
                !isBackupSchoolDetail?.status &&
                !isHomeSchooling && (
                  <Typography variant="caption" sx={style.noAccess}>
                    No Access
                  </Typography>
                )}
              {isHomeSchooling && (
                <Typography component={"span"} sx={style.homeSchool}>
                  (<HomeWorkIcon /> Elective Home Education / Not Currently in
                  Formal Education)
                </Typography>
              )}
            </Grid>
            {!refClosedStatus &&
              constant.SCOPE.CLINICIAN !== userLoggedData?.scope && (
                <AddCircleIcon
                  onClick={() => {
                    handleSetSchool();
                  }}
                  sx={{ cursor: "pointer", ...rejectedStyles }}
                />
              )}
          </Box>
          {/* <Divider /> */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={"5px"}
          >
            <Typography variant="subtitle1">Education Name: </Typography>
            <Typography sx={style.font_custom_style}>
              {isHomeSchooling
                ? ""
                : isBackupSchoolDetail?.school_name ||
                  isBackupSchoolDetail?.label}
            </Typography>
          </Box>
          <Divider />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={"5px"}
          >
            <Typography variant="subtitle1">Contact Person: </Typography>
            <Typography sx={style.font_custom_style}>
              {" "}
              {isHomeSchooling
                ? ""
                : isBackupSchoolDetail?.contact_person_name ||
                  isBackupSchoolDetail?.first_name
                ? isBackupSchoolDetail?.first_name +
                  " " +
                  isBackupSchoolDetail?.last_name
                : ""}
            </Typography>
          </Box>
          <Divider />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={"5px"}
          >
            <Typography variant="subtitle1">Contact Email: </Typography>
            <Typography sx={style.font_custom_style}>
              {" "}
              {isHomeSchooling ? "" : isBackupSchoolDetail?.email}
            </Typography>
          </Box>
          <Divider />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={"5px"}
          >
            <Typography variant="subtitle1">Contact Number: </Typography>
            <Typography sx={style.font_custom_style}>
              {isHomeSchooling ? "" : isBackupSchoolDetail?.phone_no}
            </Typography>
          </Box>
          <Divider />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={"5px"}
          >
            <Typography variant="subtitle1">Address: </Typography>
            <Typography sx={style.font_custom_style}>
              {isHomeSchooling ? "" : isBackupSchoolDetail?.address}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
    // eslint-disable-next-line
  }, [isBackupSchoolDetail, isHomeSchooling, userLoggedData]);

  return (
    <>
    {educationDetails}
      <>
        <LightBox
          title={"Assign School"}
          open={isEditDetail}
          handleClose={() => {
            setIsEditDetail(false);
          }}
        >
          <Box className={classes.clinicModal}>
            <SimilarSchoolModal isFocused={isFocused} schooList={schooList} />
            <Grid className={classes.btnWrapper} sx={{ p: "" }}>
              <Grid>
                <form onSubmit={validation.handleSubmit}>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <RadioGroup
                      value={currentTab}
                      onChange={handleChange}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        value="one"
                        control={<Radio />}
                        label="New School"
                        style={{ marginBottom: 0 }}
                        sx={isNewSchool ? style.label_color : {}}
                      />
                      <FormControlLabel
                        value="two"
                        control={<Radio />}
                        label="Existing School"
                        style={{ marginBottom: 0 }}
                        sx={!isNewSchool ? style.label_color : {}}
                      />
                      <FormControlLabel
                        value="three"
                        control={<Radio />}
                        disabled={isHomeSchooling}
                        label="Home School"
                        style={{ marginBottom: 0 }}
                        sx={!isNewSchool ? style.label_color : {}}
                      />
                    </RadioGroup>
                  </Box>
                  {currentTab === "one" && (
                    <>
                      <Grid container spacing={3} className={classes.mt_3}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Box>
                            <InputLabel sx={style.label_color}>
                              Contact Person First Name
                            </InputLabel>
                            <TextField
                              fullWidth
                              placeholder="Enter First Name"
                              {...validation.getFieldProps("first_name")}
                              error={
                                validation.touched.first_name &&
                                Boolean(validation.errors.first_name)
                              }
                              helperText={
                                validation.touched.first_name
                                  ? validation.errors.first_name
                                  : ""
                              }
                              // disabled={!isNewSchool}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Box>
                            <InputLabel sx={style.label_color}>
                              Contact Person Last Name
                            </InputLabel>
                            <TextField
                              fullWidth
                              placeholder="Enter Last Name"
                              {...validation.getFieldProps("last_name")}
                              error={
                                validation.touched.last_name &&
                                Boolean(validation.errors.last_name)
                              }
                              helperText={
                                validation.touched.last_name &&
                                validation.errors.last_name
                              }
                              // disabled={!isNewSchool}
                            />
                          </Box>
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        spacing={3}
                        className={classes.mt_3}
                        sx={{ marginBottom: "2rem" }}
                      >
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Box>
                            <InputLabel sx={style.label_color}>
                              School Name
                            </InputLabel>
                            <TextField
                              fullWidth
                              type="text"
                              name="school_name"
                              value={validation.values.school_name}
                              onChange={async (event) => {
                                const value = event.target.value;
                                validation.setFieldValue("school_name", value);
                                if (value.length >= 3) {
                                  await handleSearchGp(value.trim());
                                }
                              }}
                              onFocus={() => setIsFocused(true)}
                              onBlur={(e) => {
                                setIsFocused(false);
                                validation.handleBlur(e);
                              }}
                              placeholder="Enter School Name"
                              error={
                                validation.touched.school_name &&
                                Boolean(validation.errors.school_name)
                              }
                              helperText={
                                validation.touched.school_name &&
                                validation.errors.school_name
                              }
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Box>
                            <InputLabel sx={style.label_color}>
                              Email
                            </InputLabel>
                            <TextField
                              fullWidth
                              type={"email"}
                              placeholder="Enter Email"
                              {...validation.getFieldProps("email")}
                              error={
                                validation.touched.email &&
                                Boolean(validation.errors.email)
                              }
                              helperText={
                                validation.touched.email &&
                                validation.errors.email
                              }
                              // disabled={!isNewSchool}
                            />
                          </Box>
                        </Grid>
                      </Grid>

                      <Grid className={classes.mt_3}>
                        <Box>
                          <InputLabel sx={style.label_color}>
                            Address
                          </InputLabel>
                          <TextField
                            fullWidth
                            type="text"
                            placeholder="Enter Address"
                            {...validation.getFieldProps("address")}
                            error={
                              validation.touched.address &&
                              Boolean(validation.errors.address)
                            }
                            helperText={
                              validation.touched.address &&
                              validation.errors.address
                                ? String(validation.errors.address) // Convert errors to string
                                : "" // Empty string if there are no errors
                            }
                            rows={3}
                            // disabled={!isNewSchool}
                            multiline={true}
                            inputProps={{ maxLength: 500 }}
                          />
                        </Box>
                      </Grid>

                      <Grid container spacing={3} className={classes.mt_3}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Box>
                            <InputLabel sx={style.label_color}>
                              Contact Person Mobile
                            </InputLabel>
                            <TextField
                              fullWidth
                              type="number"
                              placeholder="Enter mobile"
                              {...validation.getFieldProps("phone_no")}
                              error={
                                validation.touched.phone_no &&
                                Boolean(validation.errors.phone_no)
                              }
                              helperText={
                                validation.touched.phone_no &&
                                validation.errors.phone_no
                              }
                              // disabled={!isNewSchool}
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Box>
                            <InputLabel sx={style.label_color}>
                              Postcode
                            </InputLabel>
                            <TextField
                              fullWidth
                              type="text"
                              placeholder="Enter Postcode"
                              {...validation.getFieldProps("postCode")}
                              error={
                                validation.touched.postCode &&
                                Boolean(validation.errors.postCode)
                              }
                              helperText={
                                validation.touched.postCode &&
                                validation.errors.postCode
                              }
                              // disabled={!isNewSchool}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </>
                  )}

                  {currentTab === "two" && (
                    <Grid width={"100%"} className={classes.mt_3}>
                      <InputLabel sx={style.label_color}>School</InputLabel>
                      <Select
                        placeholder={"Enter atleast 3 characters"}
                        onInputChange={(e: any) => handleSearchGp(e)}
                        isDisabled={isNewSchool}
                        disableCloseOnSelect={false}
                        defaultValue={isSelectedSchoolDetail?.school_name}
                        options={[placeholderObject, ...getMemoOptionsBySchool]}
                        onChange={(e: any) => handleSelect(e)}
                      />
                    </Grid>
                  )}
                  <Grid
                    className={classes.btnClr}
                    sx={{ mt: "30px", textAlign: "center" }}
                  >
                    {currentTab === "one" && (
                      <Button type="submit" variant="contained">
                        Add & Assign
                      </Button>
                    )}

                    {currentTab === "two" &&
                      isButtonEnabled &&
                      isSelectedSchoolDetail && (
                        <Button variant="contained" onClick={handleSchool}>
                          Assign
                        </Button>
                      )}

                    {currentTab === "three" && (
                      <Button variant="contained" onClick={handleHomeSchool}>
                        Assign
                      </Button>
                    )}
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Box>
        </LightBox>
      </>

      <ConfirmationModal
        open={openConfirm}
        handleClose={() => setOpenConfirm(false)}
        title="School Exists"
        message={`The Education Setting you are trying to add is already registered on the system. Please use Existing School option to search the education setting details and assign to the referral.`}
        onConfirm={() => submitAddNewSchool()}
        onCancel={() => setOpenConfirm(false)}
        confirmLabel="Continue"
        cancelLabel="Cancel"
      />

      {homeSchoolConfirmation && (
        <ConfirmationModal
          open={homeSchoolConfirmation}
          handleClose={() => setIsHomeSchoolConfirmation(false)}
          title="Confirmation"
          message={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <p style={{ marginBlock: "2px", paddingBlock: "2px" }}>
                Referral ID: {referralCaseload.caseload_unique_id}
              </p>
              <p style={{ marginBlock: "2px", paddingBlock: "2px" }}>
                Child Name: {referralCaseload.patient_detail.name}
              </p>
              <p style={{ marginBlock: "2px", paddingBlock: "2px" }}>
                You are updating the education setting for the above referral to
                home-schooling. This process will delete the education report
                already submitted by the previous education setting, along with
                any draft report saved in their education setting portal.
              </p>
              <p>Are you okay to proceed with this update?</p>
            </div>
          }
          onConfirm={() => handleAssign({ isHomeSchool: true })}
          cancelLabel="Cancel"
          confirmLabel="Confirm"
          onCancel={() => setIsHomeSchoolConfirmation(false)}
        />
      )}
    </>
  );
}
